import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { Constants } from '../../../../common/Constants';
import { useDeviceLocation } from '../../../../hooks/useDeviceLocation';
import { SuggestionListItem } from '../KeywordSearchDropdown/KeywordSearchDropdown.styled';

type Props = {
  index: number;
  onClose: () => void;
  setIsCurrentLocation?: (val: boolean) => void;
  setLocationSuggestions: (value: object[]) => void;
};

export const FindMyLocationButton = ({
  index,
  onClose,
  setIsCurrentLocation,
  setLocationSuggestions,
}: Props) => {
  const { t } = useTranslation();
  const locationForAnalytics: string = 'change search location';
  const [, setDeviceLocation] = useState<string>('');
  const { getDeviceLocation } = useDeviceLocation(setDeviceLocation);

  const handleFindMyLocationClick = (
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    event.preventDefault();
    handleDeviceLocation();
    handleAnalyticsTracking();
    onClose();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleDeviceLocation();
      handleAnalyticsTracking();
      onClose();
    }
  };

  const handleDeviceLocation = () => {
    getDeviceLocation();
    if (setIsCurrentLocation) {
      setIsCurrentLocation(true);
    }
    if (setLocationSuggestions) {
      setLocationSuggestions([]);
    }
  };

  const handleAnalyticsTracking = () => {
    adobeLinkTrackEvent({
      name: Constants.LOCATION_SEARCH.FIND_MY_LOCATION,
      location: `body:${locationForAnalytics}`,
      type: 'internal',
    });
  };

  return (
    <SuggestionListItem
      aria-label="Find my location"
      className="location-link-span"
      css={{
        '&.abyss-flex-root': {
          height: '42px',
          padding: '8px 0px',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '4px',
          fontWeight: 600,
        },
      }}
      data-auto-testid={`changeLocation_currentLocationAction`}
      data-testid={`changeLocation_currentLocationAction`}
      id={`option-${index}`}
      onClick={handleFindMyLocationClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <IconSymbol icon="my_location" />
      {t('Find my location')}
    </SuggestionListItem>
  );
};
